import {
    bexHttpClient
} from '../../clients';

class AssistantAuditService {

    async listAssistantAuditEvents(params: {
        org_id: string;
        sub_org_id: string;
        assistant_id?: string;
        resource_type?: string;
        action?: string;
        status?: string;
        limit?: number;
        page?: number;
    }): Promise<any> {
        const response = await bexHttpClient.get('/assistant-audit', { params });
        return response;
    }

}

const assistantAuditService = new AssistantAuditService();
export { assistantAuditService };
